import React from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import {getSelectDropdownStyles} from "./selectDropdownStyles";

export const SELECT_DROPDOWN_CONTAINER_TEST_ID = "select-dropdown-component-container";

const SelectDropdown = ({
                            id = 'select_dropdown',
                            inputId,
                            inputLabel,
                            className = "select-dropdown",
                            containerClassName = "id-input",
                            onChange,
                            selectValue,
                            selectLabel = undefined,
                            selectValues,
                            options,
                            isClearable = false,
                            isDisabled = false,
                            isMulti = false,
                            isCreatable = false,
                            placeholder = 'Select...',
                            dataTestId = SELECT_DROPDOWN_CONTAINER_TEST_ID,
                            autoFocus = false,
                            height = 40,
                            width = '100%',
                            styles: styleOverrides = {},
                            ...selectProps
                        }) => {

    const hasSelectLabel = selectLabel !== undefined && selectLabel !== null && selectLabel !== '';
    const hasSingleValue = hasSelectLabel || (selectValue !== undefined && selectValue !== null);
    const value = isMulti
        ? options?.filter(option => selectValues?.includes(option.value))
        : {label: hasSelectLabel ? selectLabel : selectValue, value: selectValue};

    const styles = {...getSelectDropdownStyles({height, width, isMulti}), ...styleOverrides};
    const SelectComponent = isCreatable ? CreatableSelect : Select;

    return (<div className={containerClassName} data-testid={dataTestId}>
        {inputLabel && <span className='input-group-label' data-testid={'select-label'}>{inputLabel}:</span>}
        <SelectComponent id={id}
                       inputId={inputId}
                       className={className}
                       classNamePrefix={"select-dropdown"}
                       onChange={onChange}
                       options={options}
                       value={isMulti ? value : (hasSingleValue ? value : undefined)}
                       isClearable={isClearable}
                       isMulti={isMulti}
                       placeholder={placeholder}
                       isLoading={options === undefined}
                       isDisabled={isDisabled}
                       autoFocus={autoFocus}
                       backspaceRemovesValue={false}
                       styles={styles}
                       {...selectProps}
        />
    </div>);
};

SelectDropdown.propTypes = {
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    id: PropTypes.string,
    inputId: PropTypes.string,
    isClearable: PropTypes.bool,
    inputLabel: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    selectLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectValues: PropTypes.array,
    isMulti: PropTypes.bool,
    isCreatable: PropTypes.bool,
    value: PropTypes.string,
    dataTestId: PropTypes.string,
    autoFocus: PropTypes.bool,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    styles: PropTypes.object
};

export default SelectDropdown;
